/*
 * giftbox-upsell.js
 * ギフトボックス クロスセル（モデルA / nested cart lines）
 *
 * 本体「カートに追加」ボタンのクリックを capture phase で捕捉し、
 * 同一商品フォーム内のギフトボックス用チェックボックスが ON の場合のみ、
 * 既存のテーマ側 ATC 処理を止めて /cart/add.js に items 配列を JSON 送信する。
 *   - 本体商品（id + quantity + line item properties）
 *   - ギフトボックス（id + quantity:1 + parent_id=本体variant）  ← Shopify ネイティブ nested cart lines
 * 親削除で子ライン自動削除・チェックアウト反映はプラットフォーム既定挙動に委ねる。
 * チェックOFF時は何もせず既存フローをそのまま通す。
 *
 * リスナーは document 全体ではなく、ギフトボックスを含む [data-product-form-wrapper]
 * ごとに capture phase で張る（介入力は維持しつつ影響範囲をそのフォームだけに限定）。
 */
(function () {
  'use strict';

  // 多重ロード対策（block 限定なので基本1回だが念のため）
  if (window.__giftboxUpsellInitialized) return;
  window.__giftboxUpsellInitialized = true;

  // 成功時アニメの表示時間。テーマ標準 productAddButtonForm（theme.js）の
  // durationAddButtonDisable と揃え、has-success（完了チェックマーク）の表示挙動を一致させる。
  var SUCCESS_DURATION = 3500;

  function cartRoot() {
    return (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
  }

  function showError(wrapper, message) {
    var box = wrapper && wrapper.querySelector('[data-error-display]');
    if (box) {
      box.innerHTML = '<div class="errors">' + message + '</div>';
    } else {
      // フォールバック
      window.alert(message);
    }
  }

  function refreshCartUI(addedItems) {
    return fetch(cartRoot() + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        // ヘッダー等の合計更新
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
        // テーマ標準の popdown / drawer 再描画（本体アイテムを渡す）
        document.dispatchEvent(new CustomEvent('theme:cart:popdown', {
          detail: { variant: (addedItems && addedItems[0]) || null },
          bubbles: true
        }));
      });
  }

  function handleClick(wrapper, event) {
    var button = event.target.closest && event.target.closest('[data-add-to-cart]');
    if (!button || !wrapper.contains(button)) return;

    var checkbox = wrapper.querySelector('[data-giftbox-checkbox]');
    if (!checkbox || !checkbox.checked) return; // OFF → 既存フローに任せる

    var form = button.closest('form');
    if (!form) return;

    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;
    var mainId = idInput.value;

    var giftId = checkbox.getAttribute('data-giftbox-variant-id');
    if (!giftId) return;

    // ギフトボックス自身の商品ページ等での自己参照を防ぐ
    if (String(mainId) === String(giftId)) return;

    // ここから割り込み（テーマの Alpine ハンドラを止める）
    event.preventDefault();
    event.stopImmediatePropagation();

    // フォーム関連要素を収集する。数量入力(name="quantity")や購読セレクタは
    // フォームの外側に置かれ form="<form_id>" 属性で紐づくため、DOM 子孫しか辿れない
    // querySelector では取りこぼす。テーマ本体と同じく FormData(form) を使うと
    // form= 属性で紐づく要素・選択済みコントロールのみが正しく収集される。
    var fd = new FormData(form);

    // 数量（form= 紐づけの quantity 入力を含む）
    var qtyRaw = fd.get('quantity');
    var qty = qtyRaw ? parseInt(qtyRaw, 10) : 1;
    if (!qty || qty < 1) qty = 1;

    // 本体の line item properties / selling_plan を収集（未チェックの控えは FormData に含まれない）
    var properties = {};
    var sellingPlan = null;
    fd.forEach(function (value, key) {
      var m = key.match(/^properties\[(.*)\]$/);
      if (m) {
        properties[m[1]] = value;
      } else if (key === 'selling_plan' && value) {
        sellingPlan = value;
      }
    });

    var mainItem = { id: parseInt(mainId, 10), quantity: qty };
    if (Object.keys(properties).length) mainItem.properties = properties;
    if (sellingPlan) mainItem.selling_plan = sellingPlan;

    // ギフトボックス（親=本体variant への nested child、親ラインごとに1個）
    var giftItem = { id: parseInt(giftId, 10), quantity: 1, parent_id: parseInt(mainId, 10) };

    // ローディング表示
    button.classList.add('loading');
    button.setAttribute('aria-busy', 'true');

    fetch(cartRoot() + '/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [mainItem, giftItem] })
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (result) {
        button.classList.remove('loading');
        button.removeAttribute('aria-busy');

        if (!result.ok) {
          var msg = (result.data && (result.data.description || result.data.message)) || 'カートに追加できませんでした。時間をおいて再度お試しください。';
          showError(wrapper, msg);
          return;
        }

        // テーマ標準 ATC と同じ完了アニメ（has-success = 完了チェックマーク）を出し、
        // 一定時間後に解除する（theme.js: handleSuccess → durationAddButtonDisable 後に idle）
        button.classList.add('has-success');
        setTimeout(function () { button.classList.remove('has-success'); }, SUCCESS_DURATION);

        var addedItems = (result.data && result.data.items) ? result.data.items : [];
        return refreshCartUI(addedItems);
      })
      .catch(function () {
        button.classList.remove('loading');
        button.removeAttribute('aria-busy');
        showError(wrapper, 'ネットワークエラーが発生しました。再度お試しください。');
      });
  }

  // ギフトボックスを含む商品フォームラッパーごとに capture phase でリスナーを張る。
  // document 全体には張らない（誤爆時の影響範囲をそのフォームだけに閉じ込めるため）。
  function attachWrapper(wrapper) {
    if (wrapper.__giftboxUpsellBound) return;
    wrapper.__giftboxUpsellBound = true;
    wrapper.addEventListener('click', function (event) {
      handleClick(wrapper, event);
    }, true); // capture phase（テーマ側 ATC ハンドラより先に割り込む）
  }

  function init() {
    var checkboxes = document.querySelectorAll('[data-giftbox-checkbox]');
    for (var i = 0; i < checkboxes.length; i++) {
      var wrapper = checkboxes[i].closest('[data-product-form-wrapper]');
      if (wrapper) attachWrapper(wrapper);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
